import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyDMyMjORmGlc3VqEpVLiYOINspEyWjsq1w",
  authDomain: "msh2022-224dc.firebaseapp.com",
  databaseURL: "https://msh2022-224dc-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "msh2022-224dc",
  storageBucket: "msh2022-224dc.appspot.com",
  messagingSenderId: "729854976146",
  appId: "1:729854976146:web:92c48612801776a603064b",
  measurementId: "G-XRG5KQ7DYW"
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.NODE_ENV === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const HallOneDb = getDbRef('Hall_A_Question')
const HallTwoDb = getDbRef('Hall_B_Question')
const HallOneChatDb = getDbRef('Hall_A_Chat')
const HallTwoChatDb = getDbRef('Hall_B_Chat')
const NoticeDb = getDbRef('notice')
const ActiveDb = getDbRef('token_hunter')
const NotificationDb = getDbRef('pushNotifications')

const getHallQuestionDb = (sid) => getDbRef(`hallQuestion/${sid}`)
const getHallChatDb = (sid) => getDbRef(`hallChat/${sid}`)

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)
const getLiveCheckInSessionDb = (hallNumber) => getDbRef(`liveCheckInSession/hall-${hallNumber}`)
const getLiveTokenDb = (hallNumber) => getDbRef(`missions/token-${hallNumber}`)
const getRefreshDb = (uid) => getDbRef(`shouldRefresh/${uid}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  HallOneDb,
  HallTwoDb,
  HallOneChatDb,
  HallTwoChatDb,
  NoticeDb,
  NotificationDb,
  ActiveDb,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
  getLiveCheckInSessionDb,
  getRefreshDb,
  getLiveTokenDb,
  getHallQuestionDb,
  getHallChatDb,
}
